import axios from 'axios';

export async function uploadFileInChunks(
  file: File,
  uploadUrl: string,
  chunkSize = 1024 * 1024 * 10, // 10MB

  onProgress?: (progress: {
    progress: number;
    uploaded: number;
    total: number;
    speedBps: number;
    speedKbps: number;
    speedMbps: number;
    etaSec: number;
  }) => void,
) {
  let start = 0;
  const total = file.size;

  while (start < total) {
    const end = Math.min(start + chunkSize, total);
    const chunk = file.slice(start, end);

    const headers = {
      'Content-Range': `bytes ${start}-${end - 1}/${total}`,
      'Content-Type': file.type,
    };

    const startTime = Date.now();
    await axios.put(uploadUrl, chunk, {
      headers,
      validateStatus: (status) => status === 200 || status === 308,
      onUploadProgress: (event) => {
        const uploaded = event.loaded;
        const progress = ((start + uploaded) / total) * 100;

        const elapsedSec = (Date.now() - startTime) / 1000;
        // Guard against division by zero when elapsedSec is 0 or very small
        const minElapsedSec = 0.001; // 1ms minimum
        const effectiveElapsedSec = Math.max(elapsedSec, minElapsedSec);
        const speedBps = uploaded / effectiveElapsedSec;
        const speedKbps = speedBps / 1024;
        const speedMbps = speedKbps / 1024;

        // subtract bytes already sent in previous chunks to keep ETA accurate
        const remainingBytes = total - start - uploaded;
        const etaSec = remainingBytes / speedBps;

        const progressData = {
          progress, // %
          uploaded, // bytes
          total, // bytes
          speedBps, // bytes/sec
          speedKbps,
          speedMbps,
          etaSec, // seconds remaining
        };

        onProgress?.(progressData);
      },
    });
    start = end;
    const progress = Math.round((start / total) * 100);
    console.log(`Uploaded ${progress}%`);
  }

  console.log('Upload complete');
}
